import React from "react";
import { DecisionTreeViewer } from "../../modules/assist/components";
import { demoDecisionTree } from "../../modules/assist/models";

// Assist · Décisions guidées : arbre de décision pour clarifier un choix.
export default function AssistDecisions() {
  return (
    <div className="max-w-4xl mx-auto space-y-4">
      <header className="space-y-2">
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50 mb-4">Assist · Décisions guidées</h1>
        <p className="text-sm md:text-base text-slate-600 dark:text-slate-300">
          Utilise cet arbre pour questionner ta décision et limiter les biais.
        </p>
      </header>

      <section className="space-y-3">
        <DecisionTreeViewer tree={demoDecisionTree} />
      </section>
    </div>
  );
}
